export const Menuitems = [
  {
    title: "Home",
    url: "/",
    cName: "nav-links",
    icon: "fa-solid fa-house-chimney",
  },
  {
    title: "About",
    url: "/About",
    cName: "nav-links",
    icon: "fa-solid fa-circle-info",
  },
  {
    title: "Service",
    url: "/Service",
    cName: "nav-links",
    icon: "fa-solid fa-briefcase",
  },
  {
    title: "Contact",
    url: "/Contact",
    cName: "nav-links",
    icon: "fa-solid fa-address-book",
  },
  {
    title: "Sign Up",
    url: "/signup",
    cName: "nav-links-mobile",
  },
];
